/**
 * Returns true if the number is provided
 *
 * @param {number} number - The string value to check
 * @return {boolean} True if number.  False otherwise.
 */

export function isNumber(number) {
    return typeof number === 'number' && !isNaN(number);
}
